module.exports = __webpack_public_path__ + "img/group_white.61e4a2bb.png";